/**
 * @file Branded logo header container for folder discovery.
 */

import { connect } from 'react-redux';
import compose from 'lodash.flowright';
import { graphql } from 'react-apollo';

import { AlbumFolderWithCreatorBrandDetails } from '../../graphql/queries/album-folder';
import OnboardingBrandedHeader from '../../components/onboarding/start/OnboardingBrandedHeader';

const mapStateToProps = ({ discoverAlbumFolder }) => ({
  albumFolderId: discoverAlbumFolder.albumFolderId,
});

const withFolderBranding = graphql(AlbumFolderWithCreatorBrandDetails, {
  options: ({ albumFolderId }) => ({
    variables: {
      id: albumFolderId,
    },
  }),
  props: ({ data: { albumFolder } }) => ({
    logo: albumFolder && albumFolder.account.logo_image,
  }),
  skip: ({ albumFolderId }) => !albumFolderId,
});

export default compose(
  connect(mapStateToProps),
  withFolderBranding,
)(OnboardingBrandedHeader);
